import * as React from "react"
import {Head} from "./head";
import {Footer} from "./footer";
import {Link} from "gatsby";

type Props = {
    title: string
    description?: string
    footerFixed: boolean
    container?: boolean
    children: React.ReactNode
}


export const Layout: React.FC<Props> = ({children, title, description, footerFixed,container = true }) => {
    return (
        <>
            <Head title={title} description={description}/>
            <main className={container ? "container mt-28" : ""}>
                {children}
            </main>
            <div className='text-right p-10 text-primary-600'>
            <Link to='/' >トップに戻る</Link>
            </div>
            <Footer fixed={footerFixed}/>
        </>
    )
}
